<template>
    <span>
        <b-badge :id="id" :variant="variant"><slot name="icon"></slot></b-badge>
        <b-tooltip :target="id">
            <slot name="content"></slot>    
        </b-tooltip>
    </span>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },

        variant: {
            type:  String
        }
    }
}
</script>